import { Button, Flex, InfoBox, ModalV2, Text } from "@jsq/ds/core";
import { SPACING } from "~/styles/variables";

export type EditStructureModalProps = {
  onHide: () => void;
  onConfirm: () => void;
};

// Client-side confirm only — the actual destructive re-run action lives on Structure DDQ.
export const EditStructureModal = ({ onHide, onConfirm }: EditStructureModalProps) => (
  <ModalV2
    show
    onHide={onHide}
    title="Edit structure?"
    size="small"
    data-testid="ddq-edit-structure-modal"
  >
    <ModalV2.Body>
      <Flex flexDirection="column" gap={SPACING.LARGE}>
        <Text variant="secondary-md">
          Section and question order, and any generated answers, are tied to the current
          structure.
        </Text>
        <InfoBox
          variant="warning"
          title="Re-running the document process from here will clear any generated answers for this draft."
        />
      </Flex>
    </ModalV2.Body>
    <ModalV2.Footer>
      <Flex flexDirection="row" gap={SPACING.SMALL} justifyContent="flex-end">
        <Button variant="neutral" onClick={onHide} data-testid="ddq-edit-structure-cancel">
          Cancel
        </Button>
        <Button onClick={onConfirm} data-testid="ddq-edit-structure-confirm">
          Edit structure
        </Button>
      </Flex>
    </ModalV2.Footer>
  </ModalV2>
);
